import { z } from 'zod';
import { BILLING_CONSTRAINTS } from '@/lib/constants/account';

export const paymentMethodSchema = z.object({
  fullName: z.string()
    .min(1, 'Full name is required')
    .max(BILLING_CONSTRAINTS.FULL_NAME_MAX, `Cannot exceed ${BILLING_CONSTRAINTS.FULL_NAME_MAX} characters`),
  orgName: z.string()
    .max(BILLING_CONSTRAINTS.ORG_NAME_MAX, `Cannot exceed ${BILLING_CONSTRAINTS.ORG_NAME_MAX} characters`),
  address1: z.string()
    .min(1, 'Address is required')
    .max(BILLING_CONSTRAINTS.ADDRESS_MAX, `Cannot exceed ${BILLING_CONSTRAINTS.ADDRESS_MAX} characters`),
  city: z.string()
    .min(1, 'City is required')
    .max(BILLING_CONSTRAINTS.CITY_MAX, `Cannot exceed ${BILLING_CONSTRAINTS.CITY_MAX} characters`),
  region: z.string()
    .min(1, 'State/Region is required')
    .max(BILLING_CONSTRAINTS.REGION_MAX, `Cannot exceed ${BILLING_CONSTRAINTS.REGION_MAX} characters`),
  postalCode: z.string()
    .min(1, 'Postal code is required')
    .max(BILLING_CONSTRAINTS.POSTAL_CODE_MAX, `Cannot exceed ${BILLING_CONSTRAINTS.POSTAL_CODE_MAX} characters`),
  countryIso2: z.string().min(1, 'Country is required'),
  cardNum: z.string()
    .min(13, 'Card number must be at least 13 digits')
    .max(19, 'Card number cannot exceed 19 digits')
    .regex(/^\d+$/, 'Card number must contain only digits'),
  cardMonth: z.number().min(1, 'Required').max(12),
  cardYear: z.number().min(new Date().getFullYear(), 'Card has expired'),
  cvv: z.string()
    .min(3, 'CVV must be at least 3 digits')
    .max(4, 'CVV cannot exceed 4 digits')
    .regex(/^\d+$/, 'CVV must contain only digits'),
}).refine((data) => {
  // Cross-validate that card expiry is not in the past
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // 1-indexed
  if (data.cardYear === currentYear && data.cardMonth < currentMonth) {
    return false;
  }
  return true;
}, {
  message: 'Card has expired',
  path: ['cardMonth'],
});

export type PaymentMethodFormValues = z.infer<typeof paymentMethodSchema>;
